const HARDCODED_FOV_MAP: Record<string, number> = {
  "MainScene 5.5 Room Dimensions 12' x 12'": 90,
  "MainScene 5.5 Room Dimensions W 21' x L 21'": 70,
  "MainScene 5.5 Room Dimensions W 5' x L 8'": 100,
  "MainScene 5.5 Room Dimensions W 6' x L 10'": 80,
  "MainScene 5.5 Room Dimensions W 8' x L 8'": 100,
  "MainScene 5.5 Room Dims W 12' x L 10'": 75,
  "MainScene 5.5 Room Dims W 15' x L 18'": 80,
  "MainScene 5.5 Room Dims W 16' x L 12'": 82,
};

export async function getCameraFov(
  sceneName = "MainScene 5.5 Room Dimensions 12' x 12'"
): Promise<number | null> {
  try {
    const configResponse = await fetch("/playCanvasScene/config.json");

    if (!configResponse.ok) {
      console.warn("[getCameraFov] failed to load config.json");
      return null;
    }

    const config = await configResponse.json();
    const scenes: any[] = config.scenes ?? [];

    if (!Array.isArray(scenes) || scenes.length === 0) {
      console.warn("[getCameraFov] no scenes defined in config.json");
      return null;
    }

    const sceneMeta =
      scenes.find(s => s?.name === sceneName) || scenes[0];

    const hardcoded = HARDCODED_FOV_MAP[sceneMeta?.name as string];
    if (typeof hardcoded === "number") {
      return hardcoded;
    }

    if (!sceneMeta?.url) {
      console.warn("[getCameraFov] no scene url found");
      return null;
    }

    const sceneResponse = await fetch(`/playCanvasScene/${sceneMeta.url}`);

    if (!sceneResponse.ok) {
      console.warn(
        "[getCameraFov] failed to load scene json:",
        sceneMeta.url
      );
      return null;
    }

    const sceneJson = await sceneResponse.json();
    const entities = sceneJson.entities || {};

    for (const key of Object.keys(entities)) {
      const entity = entities[key];
      const fov = entity?.components?.camera?.fov;

      if (typeof fov === "number") {
        return fov;
      }
    }

    console.warn("[getCameraFov] no camera.fov found in scene");
    return null;
  } catch (e) {
    console.warn("[getCameraFov] error while reading scene fov", e);
    return null;
  }
}
